import { render, staticRenderFns } from "./ContentPayment.vue?vue&type=template&id=789483f0"
import script from "./ContentPayment.vue?vue&type=script&lang=js"
export * from "./ContentPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports